import { type SWRResponse } from 'swr';

import { type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

const PATH = '/payments/refunds';

type ThisApi = ApiDefinition[typeof PATH]['GET'];

type Input = ThisApi['query'];
type Output = ThisApi['response'];

export const useRefunds = (params: Input | null, config?: UseNoodleSwrConfig<Output>): SWRResponse<Output> => {
  const queryString = params
    ? '?' +
      Object.entries(params)
        .filter(([, value]) => value !== undefined && value !== null)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
        .join('&')
    : null;
  const path = queryString ? `${PATH}${queryString}` : null;
  return useNoodleSwr(path, { revalidateOnFocus: false, ...config });
};

/**
 * @deprecated: Please use `useRefunds` wherever a perfectly fresh response is not worth the network time, bandwidth, and compute.
 */
const getRefunds = async (params: Input): Promise<Output> => {
  const response = await noodleApiClient.get<Output>(PATH, {
    params,
  });
  return response.data;
};

export default getRefunds;
